import React from 'react';
import tw from 'twin.macro';
import { css } from '@emotion/react';

import { Popup, type PopupPosition } from '$/components/ui/Popup';

import { EyeSolid } from '$/images/Icons';

import type { InteractionInfo } from './InteractionInfo';

export const ConditionalDisplayIcon: React.FC<{
  interaction: InteractionInfo;
  position?: PopupPosition;
  className?: string;
}> = ({ interaction, position, className }) => {
  if (!interaction.details?.displayRules || interaction.details?.displayRules.length == 0)
    return null;
  return (
    <Popup
      className={className}
      content={<span>Conditionally displayed</span>}
      trigger={
        <div
          className='mx-2'
          css={css`
            padding: 2px;
          `}
        >
          <EyeSolid
            css={css`
              ${tw`h-1e text-color-brand cursor-pointer`}
            `}
          />
        </div>
      }
      position={position ?? 'top center'}
      popperModifiers={[
        {
          preventOverflow: {
            enabled: false,
            boundariesElement: 'window',
            escapeWithReference: true,
          },
        },
      ]}
    />
  );
};
